import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { routes } from '../../../../../types/types';
import { TableAllProjects } from '../../../tables/components/TableAllProjects/TableAllProjects';
import { DocumentProcessing } from '../../../tables/components/DocumentProcessing/DocumentProcessing';
import { UsersTable } from '../../../usersPage/components/UsersTable/UsersTable';

import s from './MainRoutes.module.scss';

export const MainRoutes = () => {
  return (
    <div className={s.MainRoutes}>
      <Routes>
        <Route path={routes.tableAllProjects} element={<TableAllProjects />} />
        <Route path={routes.documentProcessing} element={<DocumentProcessing />} />
        <Route path={routes.users} element={<UsersTable />} />
      </Routes>
    </div>
  );
};
